export const en = {
  msg:
    {
      'username': 'Username',
      'password': 'Password',
      'login': 'Login',
      'username_not_found': 'Please enter your Username',
      'password_not_found': 'Please enter your Password',
      'error': 'Invalid username or password',
      'changeLanguage': '',
      'lang-en': 'English',
      'lang-ms': 'Bahasa Melayu',
      'submit_button_text': 'Submit',
      'enter': 'Enter',
      'en': 'English',
      'ms': 'Bahasa Melayu',
      'zh': 'Chinese',
      'blank_username_field': 'Please enter your username.',
      'blank_password_field': 'Please enter your password.',
      'invalid_credentials': 'Invalid username or password.',
      'copyright': 'Powered by Global Psytech'
    }
}
